import { render, staticRenderFns } from "./Estoques.vue?vue&type=template&id=0e7af949&scoped=true"
import script from "./Estoques.vue?vue&type=script&lang=js"
export * from "./Estoques.vue?vue&type=script&lang=js"
import style0 from "./Estoques.vue?vue&type=style&index=0&id=0e7af949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7af949",
  null
  
)

export default component.exports